import axios from "axios";
import { snack } from "components/toast";
import moment from "moment";
import { setGlobalLoading } from "redux/reducers/globalSlice";
import store from "redux/store";
// import { getFingerprint } from "utils/fingerprint";
import { decryptData } from "utils/secretKey";

export const skipurls = [
  "quantum",
  "/notifications/token",
  "/notifications/count",
  "/get-started",
  "/permissions/mine",
  "/users/profile",
  "/users/signin",
];

window["expirydate"] = false;
window["demo"] = false;

const trailExpired = (function () {
  let executed = false;
  let previousArgument = "";

  return function (arg: any) {
    if (!executed || arg !== previousArgument) {
      executed = true;
      previousArgument = arg;
      snack.error("Your Trial Period has expired");
    }
  };
})();

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${localStorage.getItem("token")}` || "",
  },
  withCredentials: true,
});

http.interceptors.request.use(
  async function (config) {
    store.dispatch(setGlobalLoading(true));

    // Always send cookies
    config.withCredentials = true;

    // // Ensure headers exist
    // if (!config.headers) {
    //   config.headers = {};
    // }
    // config.headers["X-Requested-With"] = "XMLHttpRequest";
    // // Attach fingerprint to request
    // try {
    //   const fp = await getFingerprint();
    //   config.headers["x-client-fingerprint"] = fp;
    // } catch (e) {
    //   console.warn("Fingerprint generation failed", e);
    // }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response: any) {
    const config = response?.data?.organization?.config;
    // if (response?.data?.data && typeof response.data.data === "string") {
    //   try {
    //     const decrypted = decryptData(response.data.data);
    //     response.data = decrypted ? JSON.parse(decrypted) : ""; // replace with real object
    //   } catch (err) {
    //     console.error("Failed to decrypt or parse response:", err);
    //     // optionally: return Promise.reject(err);
    //   }
    // }

    if (response?.config?.url.includes("users/profile")) {
      let today = moment().format("YYYY-MM-DD");
      const expiryDate = moment(config?.expirydate, "YYYY-MM-DD");

      const duration = moment.duration(expiryDate.diff(today));
      const daysDifference = duration.asDays();
      window["expirydate"] = daysDifference < -1 ? true : false;
      window["demo"] = config?.demo == "yes" ? true : false;
    }

    const skipurl = skipurls.indexOf(response?.config?.baseURL + response?.config?.url) >= 0;

    if (!skipurl && window["expirydate"] && window["demo"]) {
      setTimeout(() => {
        trailExpired(window.location.href);
      }, 1000);

      store.dispatch(setGlobalLoading(false));

      return Promise.reject({ error: "Trail expired" });
    }
    if (
      (config?.subscriptionmode == "monthly" || config?.subscriptionmode == "yearly") &&
      window["expirydate"]
    ) {
      snack.error("Your subscription ended");

      if (!window.location.href.includes("subscription")) {
        window.location.href = "/subscription";
      }
    } else {
      store.dispatch(setGlobalLoading(false));
      return response;
    }
  },
  async function (err) {
    const message = err?.response?.data?.message;
    const url = err?.request?.responseURL || "";
    const storageSystem: any = new URL(url).searchParams.get("storageSystem");
    // console.log("cronHttp error:", err?.response?.data, err?.request);
    // console.log("Test-2");
    store.dispatch(setGlobalLoading(false));
    if (err.message === "Network Error") {
      alert("Network Error");
    }

    // console.log("Test-3", message, err?.request?.responseURL);
    if (message == "invalid_grant") {
      const targetUrlOneDrive = `${window.location.origin}/storage/cloud-storage/one-drive`;
      const targetUrlGoogleDrive = `${window.location.origin}/storage/cloud-storage/google-drive`;
      if (
        (storageSystem === "MICROSOFT" && window.location.href !== targetUrlOneDrive) ||
        (storageSystem === "GOOGLE" && window.location.href !== targetUrlGoogleDrive)
      ) {
        snack.error("Drive Authentication error. Redirecting...2");
        setTimeout(() => {
          window.location.href =
            storageSystem === "MICROSOFT" ? targetUrlOneDrive : targetUrlGoogleDrive;
        }, 500);
      }

      return Promise.reject(err);
    }
    // use for expiry date
    // if (
    //   err.response.data.statusCode === 422
    // ) {
    //   snack.error(err.response.data.message);
    // }

    // if (err.response.data.statusCode === 401 && err.response.config.method === "get") {
    //   console.log(err, "err.response");
    //   snack.error("Session expired. Please login again.");
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("userId");
    //   localStorage.removeItem("isLogIn");
    //   localStorage.removeItem("expiryPopupDismissedUntil");
    //   window.location.href = "/login";
    // }

    if (err.response?.status === 401 && !err.config._retry) {
      const originalRequest = err.config;

      // Prevent infinite loop: don't apply logic to refresh endpoint
      if (originalRequest.url.includes("/users/refresh")) {
        return Promise.reject(err);
      }

      err.config._retry = true; // avoid infinite loop
      // try {
      //   // Call backend to refresh token
      //   await http.post("/users/refresh");

      //   // Retry original request with new cookie
      //   return http(err.config);
      // } catch (refreshError) {
      //   // Refresh also failed -> logout
      //   snack.error("Session expired. Please login again.");
      //   localStorage.clear(); // optional, since cookies handle JWT now
      //   window.location.href = "/login";
      //   return Promise.reject(refreshError);
      // }

      //   snack.error("Session expired. Please login again.");
      if (window.location.href !== `${window.location.origin}/login`) {
        console.log("coming inside");
        localStorage.clear(); // optional, since cookies handle JWT now
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
